// extracted by mini-css-extract-plugin
export var body = "_2v-1";
export var bodyPadded = "_2v-2";
export var chevron = "_2v-4";
export var chevronOpen = "_2v-5";
export var header = "_2v-0";
export var icon = "_2v-3";